import {
  TeamContainerRow,
  TeamHeader,
  TeamImageColumn,
  TeamImageRow,
} from './styled';
import { OneColumnExpanded } from '../../styled';
import { useContentfulImage } from '@/hooks/useContentfulImage';
import DeferRenderUntilIntersecting from '@/components/DeferRenderUntilIntersecting';
import { Helmet } from 'react-helmet-async';

interface GalleryImage {
  title?: string;
  description?: string;
  url?: string;
}

interface Props {
  title?: string;
  markdownContent: string[];
  gallery: GalleryImage[];
}

export const Team = ({ title, markdownContent, gallery }: Props) => {
  return (
    <TeamContainerRow justifyContent="center" bgColor="#EAF3FF">
      <OneColumnExpanded>
        <TeamHeader data-cy-id="team">
          <h2>{title}</h2>
          <p>{markdownContent[0]}</p>
          <p>{markdownContent[1]}</p>
        </TeamHeader>
        <TeamImageRow justifyContent="center">
          {gallery.map((image, i) => (
            <TeamImages image={image} key={i} />
          ))}
        </TeamImageRow>
      </OneColumnExpanded>
    </TeamContainerRow>
  );
};

interface TeamImagesProps {
  image: GalleryImage;
}

const TeamImages = ({ image }: TeamImagesProps) => {
  const imageContentful = useContentfulImage({
    url: image && image.url,
    format: 'avif',
  });
  const imageContentfulFallback = useContentfulImage({
    url: image && image.url,
    format: 'jpg',
  });

  return (
    <>
      <Helmet>
        <link rel="prefetch" href={imageContentful?.src} />
        <link rel="prefetch" href={imageContentfulFallback?.src} />
      </Helmet>
      <TeamImageColumn colMd={4}>
        {imageContentful && imageContentfulFallback && (
          <DeferRenderUntilIntersecting>
            {() => (
              <picture>
                <source srcSet={imageContentful.srcSet} type="image/avif" />
                <img
                  src={imageContentfulFallback.src}
                  alt={image.title ?? ''}
                  height="240"
                />
              </picture>
            )}
          </DeferRenderUntilIntersecting>
        )}
      </TeamImageColumn>
    </>
  );
};
